import { createSelector } from 'reselect';

import { GlobalState } from '../../reducers';
import { FetchGroupsArguments } from './actions';
import utils from './utils';

const groupsStateSelector = (state: GlobalState) => state.apps.appManagement.groups;

const groupsSelector = createSelector([
  groupsStateSelector,
],
(groupsState) => ({
  currentPage: groupsState.currentPage,
  filterOs: groupsState.filterOs,
  groups: groupsState.items,
  hasError: groupsState.hasError,
  isLoading: groupsState.isLoading,
  itemsPerPage: groupsState.itemsPerPage,
  searchQuery: groupsState.searchQuery,
  totalItems: groupsState.totalItems,
}));

const fetchGroupsArgumentsSelector = createSelector([
  groupsStateSelector,
],
(groupsState): FetchGroupsArguments => {
  const osFilters = utils.constructOsFilters(groupsState.filterOs);

  return {
    entriesPerPage: groupsState.itemsPerPage,
    osFilters,
    paginationPage: groupsState.currentPage,
    searchQuery: groupsState.searchQuery,
  };
});

const filterOsSelector = createSelector([
  groupsStateSelector,
],
(groupsState) => groupsState.filterOs);

const searchQuerySelector = createSelector([
  groupsStateSelector,
],
(groupsState) => groupsState.searchQuery);

const currentGroupSelector = createSelector([
  groupsStateSelector,
],
(groupsState) => groupsState.currentGroup[0] ?? null);

const currentGroupKindSelector = createSelector([
  groupsStateSelector,
],
(groupsState) => groupsState.currentGroup[0]?.recent.kind ?? null);

const currentGroupSettingsSelector = createSelector([
  groupsStateSelector,
],
(groupsState) => groupsState.currentGroup[0]?.settings ?? null);

export default {
  currentGroupKindSelector,
  currentGroupSelector,
  currentGroupSettingsSelector,
  fetchGroupsArgumentsSelector,
  filterOsSelector,
  groupsSelector,
  searchQuerySelector,
};
